import React from 'react';
import PropTypes from 'prop-types';

import LoadingSpinner from '../../../LoadingSpinner/LoadingSpinner';

const WelcomeMessageVariation = ({
  variation,
  index,
  isRephrasingIndex,
  onRephrase,
  onEditManually,
  onSelect,
}) => {
  const itemIsRephrasing = isRephrasingIndex === index;

  return (
    <div
      className="personalization__welcomeMessageVariation"
      data-testid={`welcome-message-variation:${index}`}
    >
      <div className="modal__section">

        <div className="personalization__welcomeMessageVariationHeader modal__subsection">
          <div className="personalization__welcomeMessageVariationTitle modal__subheader">
            Variation
            {' '}
            {variation.number}
            {variation.rephrased ? ' - Rephrased' : ''}
          </div>
          <div className="personalization__welcomeMessageVariationActions">

            {variation.canRephrase && (
              <button
                type="button"
                className="modal__textBtn modal__textBtn--minor"
                onClick={() => onRephrase(index)}
                data-testid={`welcome-message-rephrase:${index}`}
              >
                Rephrase with AI
              </button>
            )}

            <button
              type="button"
              className="modal__textBtn modal__textBtn--minor"
              onClick={() => onEditManually(variation.text)}
            >
              Edit Manually
            </button>

          </div>
        </div>

        <div
          className="modal__subsection modal__description modal__description--long"
          data-testid={`welcome-message-variation-text:${index}`}
        >
          {itemIsRephrasing ? (
            <div className="personalization__loading">
              <LoadingSpinner />
            </div>
          ) : variation.text}
        </div>

        { !itemIsRephrasing && (
          <div className="modal__subsection modal__btns modal__btns--inline">
            <button
              type="button"
              onClick={(e) => onSelect(e, index).catch(console.error)}
              className="modal__btn modal__btn--secondary modal__btn--inline"
              disabled={itemIsRephrasing}
              data-testid={`welcome-message-use:${index}`}
            >
              Select & Save Message
            </button>
          </div>
        )}

      </div>
    </div>
  );
};

WelcomeMessageVariation.propTypes = {
  variation: PropTypes.shape({
    text: PropTypes.string,
    canRephrase: PropTypes.bool,
    rephrased: PropTypes.bool,
    number: PropTypes.number,
  }).isRequired,
  index: PropTypes.number.isRequired,
  isRephrasingIndex: PropTypes.number,
  onRephrase: PropTypes.func.isRequired,
  onEditManually: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

WelcomeMessageVariation.defaultProps = {
  isRephrasingIndex: null,
};

export default WelcomeMessageVariation;
